import { Box, Typography } from "@mui/material";
import { ListContextProvider } from "react-admin";
import { settings } from "app";

import GradesDatagrid from "./GradesDatagrid";
import { SEMESTER_GRID_GAP, semesterGridColumns } from "./semesterGrid";

// Wrapped in a Box, not a fragment — the grid below would otherwise treat the header and the table
// as separate cells.
const PickedDisciplinesTable = ({ title, rows, educationId, onGradeChanged, isMobile }) => (
  // minWidth: 0 - a grid item otherwise stays as wide as its table and spills into the next column.
  <Box sx={{ minWidth: 0 }}>
    {/* shadowBox is sized for a full-width section — drop its width/margin, keep the framing. */}
    <Box
      sx={{
        ...(isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox),
        width: "auto",
        maxWidth: "none", // shadowBox's cap assumes its 2rem side margins, which are dropped here
        margin: 0,
        marginTop: "0.5rem",
        overflowX: "auto", // a table wider than the column scrolls here instead of widening the page
      }}
    >
      <Typography
        color="info"
        fontWeight={600}
        sx={{ ml: 2, mb: 2 }}
      >
        {title}
      </Typography>
      {/* px matches the title's ml, so the table lines up with it instead of hugging the frame. */}
      <Box sx={{ px: 2 }}>
        {rows.length > 0 ? (
          <ListContextProvider
            value={{
              data: rows,
              ids: rows.map(row => row.id),
              total: rows.length,
              loaded: true,
            }}
          >
            <GradesDatagrid
              educationId={educationId}
              onGradeChanged={onGradeChanged}
              showTypeColumn={false}
            />
          </ListContextProvider>
        ) : (
          <Typography
            variant="body1"
            color="secondary"
          >
            Няма намерени данни
          </Typography>
        )}
      </Box>
    </Box>
  </Box>
);

// Rows arrive already split by type and scoped to the selected course (see gradesByType).
const PickedDisciplines = ({ electiveRows, facultativeRows, educationId, onGradeChanged, isMobile }) => (
  <Box
    sx={{
      display: "grid",
      // Same columns as the grades tabs above: side by side while both fit, otherwise wrapped (semesterGrid.js).
      gridTemplateColumns: semesterGridColumns(isMobile),
      gap: SEMESTER_GRID_GAP,
      margin: (isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox).margin,
    }}
  >
    <PickedDisciplinesTable
      title="Избираеми дисциплини"
      rows={electiveRows}
      educationId={educationId}
      onGradeChanged={onGradeChanged}
      isMobile={isMobile}
    />
    <PickedDisciplinesTable
      title="Факултативни дисциплини"
      rows={facultativeRows}
      educationId={educationId}
      onGradeChanged={onGradeChanged}
      isMobile={isMobile}
    />
  </Box>
);

export default PickedDisciplines;
